"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1: function() {
        return _Body1.Body1;
    },
    Body1Strong: function() {
        return _Body1Strong.Body1Strong;
    },
    Body1Stronger: function() {
        return _Body1Stronger.Body1Stronger;
    },
    Body2: function() {
        return _Body2.Body2;
    },
    Caption1: function() {
        return _Caption1.Caption1;
    },
    Caption1Strong: function() {
        return _Caption1Strong.Caption1Strong;
    },
    Caption1Stronger: function() {
        return _Caption1Stronger.Caption1Stronger;
    },
    Caption2: function() {
        return _Caption2.Caption2;
    },
    Caption2Strong: function() {
        return _Caption2Strong.Caption2Strong;
    },
    Display: function() {
        return _Display.Display;
    },
    LargeTitle: function() {
        return _LargeTitle.LargeTitle;
    },
    Subtitle1: function() {
        return _Subtitle1.Subtitle1;
    },
    Subtitle2: function() {
        return _Subtitle2.Subtitle2;
    },
    Subtitle2Stronger: function() {
        return _Subtitle2Stronger.Subtitle2Stronger;
    },
    Text: function() {
        return _Text.Text;
    },
    Title1: function() {
        return _Title1.Title1;
    },
    Title2: function() {
        return _Title2.Title2;
    },
    Title3: function() {
        return _Title3.Title3;
    },
    body1ClassNames: function() {
        return _Body1.body1ClassNames;
    },
    body1StrongClassNames: function() {
        return _Body1Strong.body1StrongClassNames;
    },
    body1StrongerClassNames: function() {
        return _Body1Stronger.body1StrongerClassNames;
    },
    body2ClassNames: function() {
        return _Body2.body2ClassNames;
    },
    caption1ClassNames: function() {
        return _Caption1.caption1ClassNames;
    },
    caption1StrongClassNames: function() {
        return _Caption1Strong.caption1StrongClassNames;
    },
    caption1StrongerClassNames: function() {
        return _Caption1Stronger.caption1StrongerClassNames;
    },
    caption2ClassNames: function() {
        return _Caption2.caption2ClassNames;
    },
    caption2StrongClassNames: function() {
        return _Caption2Strong.caption2StrongClassNames;
    },
    displayClassNames: function() {
        return _Display.displayClassNames;
    },
    largeTitleClassNames: function() {
        return _LargeTitle.largeTitleClassNames;
    },
    renderText_unstable: function() {
        return _Text.renderText_unstable;
    },
    subtitle1ClassNames: function() {
        return _Subtitle1.subtitle1ClassNames;
    },
    subtitle2ClassNames: function() {
        return _Subtitle2.subtitle2ClassNames;
    },
    subtitle2StrongerClassNames: function() {
        return _Subtitle2Stronger.subtitle2StrongerClassNames;
    },
    textClassNames: function() {
        return _Text.textClassNames;
    },
    title1ClassNames: function() {
        return _Title1.title1ClassNames;
    },
    title2ClassNames: function() {
        return _Title2.title2ClassNames;
    },
    title3ClassNames: function() {
        return _Title3.title3ClassNames;
    },
    useTextStyles_unstable: function() {
        return _Text.useTextStyles_unstable;
    },
    useText_unstable: function() {
        return _Text.useText_unstable;
    }
});
const _Text = require("./Text");
const _Body1 = require("./Body1");
const _Body1Strong = require("./Body1Strong");
const _Body1Stronger = require("./Body1Stronger");
const _Body2 = require("./Body2");
const _Caption1 = require("./Caption1");
const _Caption1Strong = require("./Caption1Strong");
const _Caption1Stronger = require("./Caption1Stronger");
const _Caption2 = require("./Caption2");
const _Caption2Strong = require("./Caption2Strong");
const _Display = require("./Display");
const _LargeTitle = require("./LargeTitle");
const _Subtitle1 = require("./Subtitle1");
const _Subtitle2 = require("./Subtitle2");
const _Subtitle2Stronger = require("./Subtitle2Stronger");
const _Title1 = require("./Title1");
const _Title2 = require("./Title2");
const _Title3 = require("./Title3");
